import { Backdrop, Box, Button, Checkbox, CircularProgress, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { submitCommentsOfNew } from '../../feature/api/news'
import { toast } from 'react-toastify'

const Comment = ({id}) => {
    const dispatch = useDispatch()
    const [name,setName] = useState()
    const [mobile,setMobile] = useState()
    const [comment,setComment] = useState()
    const isLoadingNumber = useSelector(state => state.news.isLoadingNumber)
    const [Bot,setBot] = useState(false)
    const handleForm = (e) =>{
        e.preventDefault()
        if(Bot){
            if(name && mobile && comment ){
                dispatch(submitCommentsOfNew({
                    text:comment,
                    id:id,
                    name:name,
                    phone : mobile
                }))
                setName("")
                setMobile("")
                setComment("")
                setBot(false)
            }

        }else{
            toast.error('لطفا گزینه من ربات نیستم را فعال نمایید ')
        }
    }
    

  return (
    <Box component={"form"} onSubmit={handleForm} display={"flex"} flexDirection={"column"} alignItems={"flex-start"} border="1px solid #000" p="10px" borderRadius={"30px"}  gap={2}  
    // border="1px solid #EF7C00"
    >
        <Typography color="#EF7C00" fontSize={"24px"} fontWeight={700}>نظرات خود را با ما در میان بگذارید</Typography>
        <input placeholder='نام و نام خانوداگی' value={name} onChange={e => setName(e.target.value)} type="text" style={{color:'#fff',width:'100%', border:'1px solid #dc7200',backgroundColor:'inherit',padding:'10px',borderRadius:'30px',outline:'none'}} />
        <input placeholder=' شماره تماس جهت برقراری ارتباط در صورت نیاز ' type="tel" value={mobile} onChange={e => setMobile(e.target.value)}  style={{color:'#fff',width:'100%', border:'1px solid #dc7200',backgroundColor:'inherit',outline:'none',padding:'10px',borderRadius:'30px'}} />
        <textarea type="text" value={comment} onChange={(e) => setComment(e.target.value)} placeholder='نظر شما' style={{height:'100px',color:'#fff',width:'100%', border:'1px solid #dc7200',backgroundColor:'inherit',padding:'10px',outline:'none',borderRadius:'20px'}} />
        <Box border="1px solid #EF7C00" borderRadius={"10px"} p="5px 10px" display={"flex"} justifyContent={"space-between"}>
            <Box display={"flex"} gap={1} alignItems={"center"} >
                <Checkbox value={Bot} onChange={(e)=>setBot(!Bot)} sx={{ border:'1px solid #EF7C00',borderRadius:0,p:0}}  />
                <Typography color="#fff">من ربات نیستم</Typography>
            </Box>
            <img src="/images/captch.png" alt="" />
        </Box>
        <Button type='submit' variant='contained' fullWidth sx={{fontWeight:'bold',bgcolor:'#dc7200',borderRadius:'20px',p:'7px 30px'}}>ارسال پیام</Button>
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={isLoadingNumber}
           
            >
            <CircularProgress color="inherit" />
            </Backdrop>
    </Box>
  )
}

export default Comment